import { render } from "./StoreTaxLegal.vue?vue&type=template&id=48838aba&scoped=true"
import script from "./StoreTaxLegal.vue?vue&type=script&lang=js"
export * from "./StoreTaxLegal.vue?vue&type=script&lang=js"

import "./StoreTaxLegal.vue?vue&type=style&index=0&id=48838aba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48838aba"]])

export default __exports__